<template>
  <div class="boss-page">
    <van-nav-bar title="绩效合理性分析" left-arrow @click-left="$router.back()"/>
    <section class="month">
      <button @click="change(-1)">
        <van-icon name="arrow-left"/>
      </button>
      <b>{{ month.replace('-', ' 年 ') }} 月</b>
      <button @click="change(1)">
        <van-icon name="arrow"/>
      </button>
    </section>
    <van-skeleton v-if="loading" title :row="9"/>
    <main v-else><p class="empty-note">系统信号用于提示需要人工复核的配置问题，不直接判定指标错误。</p>
      <article v-for="item in data.issues||[]" :key="item.type+item.positionName" :class="['issue',item.severity]">
        <header><b>{{ item.title }}</b><em>{{ label(item.type) }}</em></header>
        <p>{{ item.detail }}</p><small>{{ item.positionName }} · 平均 {{ num(item.averageScore) }} 分</small></article>
      <van-empty v-if="!(data.issues||[]).length" description="暂未发现明显系统性异常"/>
    </main>
  </div>
</template>
<script>
/**
 * Boss 绩效合理性分析：识别指标过严/过松、职责偏差等需人工复核的信号。
 */
import coreapi from '@/utils/coreapi';

export default {
  data() {
    const d = new Date();
    return {month: this.$route.query.month || `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`, data: {}, loading: false}
  }, mounted() {
    this.load()
  }, methods: {
    num(v) {
      return Number(v || 0).toFixed(1)
    }, label(v) {
      return {KPI_TOO_STRICT: '指标过严', KPI_TOO_LOOSE: '指标过松', RESPONSIBILITY_GAP: '职责偏差', DATA_COMPLETENESS: '数据完整性'}[v] || v
    }, async load() {
      this.loading = true;
      try {
        this.data = await coreapi.bossRationality(this.month)
      } catch (e) {
        this.$toast.fail(e.message)
      } finally {
        this.loading = false
      }
    }, change(n) {
      const p = this.month.split('-'), d = new Date(+p[0], +p[1] - 1 + n, 1);
      this.month = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
      this.load()
    }
  }
}</script>
<style lang="less" scoped>@import './boss.less';

.issue {
  border-left: .07rem solid #D32F2F
}

.issue.HIGH {
  border-color: #D32F2F
}

.issue header {
  display: flex;
  justify-content: space-between
}

.issue em {
  padding: .06rem .13rem;
  color: #9a651f;
  font-size: .21rem;
  font-style: normal;
  background: #fff3e5;
  border-radius: .24rem
}

.issue.HIGH em {
  color: #a64040;
  background: #fff0f0
}

.issue p {
  line-height: 1.6;
  color: #55586b
}

.issue small {
  color: #9295a7
}</style>



// WEBPACK FOOTER //
// src/views/boss/Rationality.vue